import script from "./DashboardTongQuanCongViec.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardTongQuanCongViec.vue?vue&type=script&setup=true&lang=js"

import "./DashboardTongQuanCongViec.vue?vue&type=style&index=0&id=7ebc777a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ebc777a"]])

export default __exports__